export function CustomDot({ onClick, active }) {
    return (
        <div
            className={active ? 'carousel-dot active' : 'carousel-dot'}
        />
    );
}
